import ChoosePronoun from "../../components/ClassOne/English/ChoosePronoun";
import PronounWorksheet from "../../components/ClassOne/English/FillBlankPronoun";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/english/pronouns/choose-the-pronoun", title: "Choose the Pronoun", component: ChoosePronoun },
    { url: "/class-one/english/pronouns/fill-the-blanks", title: "Fill in the Blanks", component: PronounWorksheet },
];


export default topics;